import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'

export const startLti13ResourceSelection = (
  lmsCode,
  context_obj_id,
  connectedCourses,
  assessmentsOnly,
  readingLinksOnly,
  currentPage
) => {
  ReactDOM.render(
    <App 
      lmsCode={lmsCode}
      contextObjId={context_obj_id}
      connectedCourses={connectedCourses}
      assessmentsOnly={assessmentsOnly}
      readingLinksOnly={readingLinksOnly}
      currentPage={currentPage}
    />,
    document.getElementById('lti13App')
  )
}
